import { Image } from "@cd2/components/build/es6"
import { IComponentProps } from "@cd2/tools/build/es6"
import React from "react"
import bear from "../images/bear.png"
import dog from "../images/dog.png"
import books from "../images/books.jpg"
import spacePug from "../images/dog.png"
import elephant from "../images/elephant.png"
import fileCabinet from "../images/filecabinet.jpg"
import hedgehog from "../images/hedgehog.png"
import letterBottle from "../images/letterBottle.jpg"
import flyingPig from "../images/pig.png"
import speak from "../images/speak.jpg"
import squid from "../images/squid.png"
import stack from "../images/stack.jpg"
import folder from "../images/folder.png"
import { IContentOverrides } from "../types/schema"

type IImageOption = keyof IContentOverrides

const hardcodedImages: Record<keyof IContentOverrides, any> = {
  books,
  elephant,
  hedgehog,
  spacePug,
  flyingPig,
  squid,
  bear,
  dog,
  fileCabinet,
  letterBottle,
  speak,
  stack,
  folder,
}

export function FileboyImageOrLocalBackgroundImage({
  image,
  ...imageProps
}: { image: IImageOption } & Omit<IComponentProps<typeof Image.Background>, "src">) {
  const imageSrc = hardcodedImages[image]
  if (!imageSrc) {
    return null
  }
  return <Image.Background {...imageProps} src={imageSrc} />
}

export function FileboyImageOrLocalImage({
  image,
  ...imageProps
}: { image: IImageOption } & Omit<IComponentProps<typeof Image>, "src">) {
  const imageSrc = hardcodedImages[image]
  if (!imageSrc) {
    return null
  }
  return <Image {...imageProps} src={imageSrc} />
}
